import { render, staticRenderFns } from "./RulesDetail.vue?vue&type=template&id=c503a28a"
import script from "./RulesDetail.vue?vue&type=script&lang=ts"
export * from "./RulesDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports